export type DataErrorCode = 'ko_unknown' | 'parcel_unknown' | 'outside_region' | 'too_large' | 'fetch' | 'nodata';

export class DataError extends Error {
  constructor(public code: DataErrorCode, message: string, public detail?: Record<string, unknown>) { super(message); }
}

/** fetch with one automatic retry (SPEC §8.6). */
export async function fetchRetry(url: string, init?: RequestInit): Promise<Response> {
  let last: unknown;
  for (let attempt = 0; attempt < 2; attempt++) {
    try {
      const r = await fetch(url, init);
      if (r.ok || r.status === 404) return r;
      last = new Error(`HTTP ${r.status} ${url}`);
    } catch (e) {
      last = e;
    }
    if (attempt === 0) await new Promise((res) => setTimeout(res, 400));
  }
  throw new DataError('fetch', `fetch failed: ${url}`, { cause: String(last) });
}

const cache = new Map<string, Promise<unknown>>();

/** JSON fetch with an in-memory cache; null on 404. */
export function fetchJson<T>(url: string): Promise<T | null> {
  let p = cache.get(url) as Promise<T | null> | undefined;
  if (!p) {
    p = fetchRetry(url).then((r) => (r.status === 404 ? null : (r.json() as Promise<T>)));
    p.catch(() => cache.delete(url));
    cache.set(url, p);
  }
  return p;
}
